import { render } from "./ResultsEntitiesComponent.vue?vue&type=template&id=1e85f98d"
import script from "./ResultsEntitiesComponent.vue?vue&type=script&lang=js"
export * from "./ResultsEntitiesComponent.vue?vue&type=script&lang=js"

import "./ResultsEntitiesComponent.vue?vue&type=style&index=0&id=1e85f98d&lang=scss"
script.render = render

export default script